<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close color="accent">X</button>
</mat-dialog-actions>

<p class="mat-body">
  Check the StudyList on the viewer
  <a [href]="studylisturl" target="_blank">here</a>
</p>
